// @flow
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';

import type {Node} from 'react';

import './IconButton.less';

type Props = {
    markup?: string,
    disabled?: boolean,
    onClick?: () => mixed,
    children?: Node,
    'data-wdio': string
};

const noop = function() {};

const IconButton = ({
    markup,
    disabled,
    onClick = noop,
    children,
    ...rest
}: Props) => (
    <button
        className="IconButton btn"
        disabled={disabled}
        onClick={onClick}
        data-wdio={`IconButton__${rest['data-wdio']}`}
    >
        <SVGIcon
            markup={markup}
            className={disabled ? 'text-default' : 'text-link'}
        />
        {children}
    </button>
);

export default IconButton;
